import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";

export interface SimpleDialogRawProps {
	title: string;
	message?: string;
	open: boolean;
	onClose: (value?: string) => void;
}
export const SimpleDialogRaw = ({
	title,
	message,
	open,
	onClose,
	...other
}: SimpleDialogRawProps) => {
	const handleOk = () => {
		onClose("OK");
	};
	return (
		<Dialog maxWidth="xs" open={open} {...other}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent dividers>
				<DialogContentText>{message}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleOk}>Ok</Button>
			</DialogActions>
		</Dialog>
	);
};
